import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { CookiePolicyPage } from '@/pages/CookiePolicyPage';

export const cookiePolicyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cookie-policy',
  component: CookiePolicyPage,
});
